import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateQualityPGFormsInput,
    QualityPGForms,
    UpdateQualityPGFormsInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class QualityPgFormsService {
    private amplifyClient = generateClient();

    constructor() {}

    async listQualityPGForms(): Promise<QualityPGForms[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listQualityPGForms
                })
            ).data.listQualityPGForms.items;
            if (data) return data as QualityPGForms[];
        } catch (error) {
            console.error('Error finding QualityPGForms:', error);
            return null;
        }
    }

    async GetQualityPGFormByProductID(): Promise<QualityPGForms[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.GetQualityPGFormByProductID
                })
            ).data.GetQualityPGFormByProductID.items;
            if (data) return data as QualityPGForms[];
        } catch (error) {
            console.error('Error finding QualityPGForms:', error);
            return null;
        }
    }

    async createQualityPGForms(
        input: CreateQualityPGFormsInput
    ): Promise<QualityPGForms> {
        try {
            const client = (
                await this.amplifyClient.graphql({
                    query: mutations.createQualityPGForms,
                    variables: {
                        input
                    }
                })
            ).data.createQualityPGForms;
            if (client) return client as QualityPGForms;
        } catch (error) {
            console.error('Error creating QualityPGForms:', error);
            return null;
        }
    }
    async updateQualityPGForms(
        input: UpdateQualityPGFormsInput
    ): Promise<QualityPGForms> {
        try {
            const client = (
                await this.amplifyClient.graphql({
                    query: mutations.updateQualityPGForms,
                    variables: {
                        input
                    }
                })
            ).data.updateQualityPGForms;
            if (client) return client as QualityPGForms;
        } catch (error) {
            console.error('Error creating QualityPGForms:', error);
            return null;
        }
    }
}
